"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POutputDatum = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var types_1 = require("../../../type_system/types.js");
var PDatumHash_1 = require("../../V1/ScriptsHashes/PDatumHash.js");
exports.POutputDatum = (0, pstruct_1.pstruct)({
    NoDatum: {},
    DatumHash: { datumHash: PDatumHash_1.PDatumHash.type },
    InlineDatum: { datum: types_1.data }
});
